import { render } from "./website.vue?vue&type=template&id=03f3212e"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__